import React from "react";
import { Close, Menu } from "@mui/icons-material";
import {
  AppBar,
  Box,
  Button,
  Hidden,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import Drawer from "./Drawer";
import NavTabs from "./NavTabs";

const MainNavigation = (props) => {
  const { mobileOpen, handleDrawerToggle } = props;

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          overflow: "hidden",
          backdropFilter: "blur(10px)",
          width: "100%",
          display: "flex",
          backgroundColor: (theme) => theme.palette.background.navigation,
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            position: "relative",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Hidden mdUp implementation="css">
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerToggle}
                edge="start"
                sx={{ borderRadius: "10px" }}
              >
                {!mobileOpen ? <Menu /> : <Close />}
              </IconButton>
            </Hidden>
            <Box sx={{ display: "flex", ml: "5vw" }}>
              <Typography
                variant="body1"
                sx={{
                  textTransform: "uppercase",
                  display: "flex",
                  justifySelf: "center",
                  color: (theme) => theme.palette.primary.light,
                  fontWeight: "bolder",
                }}
              >
                igugu
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  textTransform: "uppercase",
                  display: "flex",
                  justifySelf: "center",
                  color: (theme) => theme.palette.secondary.main,
                }}
              >
                empire
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{ display: "flex", overflow: "hidden", alignItems: "center" }}
          >
            <Box sx={{ display: { xs: "none", md: "flex" }, mr: "2vw" }}>
              <NavTabs />
            </Box>
            <a href="#contact">
              <Button variant="contained" color="primary" type="button">
                contact
              </Button>
            </a>
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer handleDrawerToggle={handleDrawerToggle} mobileOpen={mobileOpen} />
    </>
  );
};

export default MainNavigation;
